import { render, staticRenderFns } from "./ResetPasswordWrapper.vue?vue&type=template&id=c363325c&scoped=true"
import script from "./ResetPasswordWrapper.vue?vue&type=script&lang=js"
export * from "./ResetPasswordWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c363325c",
  null
  
)

export default component.exports